var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("label", { attrs: { for: _vm.id } }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
        _vm.required
          ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          : _vm._e(),
      ]),
      _c(
        "textarea",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form[_vm.name],
                  expression: "form[name]",
                },
              ],
              staticClass: "form-control",
              attrs: { id: _vm.id, rows: _vm.rows, readonly: _vm.readonly },
              domProps: { value: _vm.form[_vm.name] },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, _vm.name, $event.target.value)
                },
              },
            },
            "textarea",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _c("suc-field-has-error", { attrs: { form: _vm.form, field: _vm.name } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }